export const GET_CONSTANTS = "GET_CONSTANTS";
export const GET_CONSTANTS_SUCCESS = "GET_CONSTANTS_SUCCESS";
export const SUPPORT_CHAT_SOUND = "SUPPORT_CHAT_SOUND";
export const UNREAD_CHAT_COUNT_ADMIN = "UNREAD_CHAT_COUNT_ADMIN";
export const SET_FORUM_READ_COMMENTS = "SET_FORUM_READ_COMMENTS";
export const SET_TICKET_COUNT = "SET_TICKET_COUNT";
export const UNREAD_ERX_OFFLINE_COUNT = "UNREAD_ERX_OFFLINE_COUNT";
export const SET_FORUM_READ_TOPICS = "SET_FORUM_READ_TOPICS";
export const DOCTOR_AND_NURSE_LIST = "DOCTOR_AND_NURSE_LIST";
export const CONSULT_NATURE_LIST = "CONSULT_NATURE_LIST";
export const SUPPORT_STAFF = "SUPPORT_STAFF";

